export default __webpack_public_path__ + "static/media/promo_02.1bb1d604.jpg";